import config from "config/config";
export async function registerAgent(
  alternateId,
  agentId,
  firstName,
  lastName,
  identityNumber,
  postalCode,
  MobileNumber,
  notificationPreference,
  emailId,
  userName,
  password,
  roleId,
  userSecurityQA
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      AlternateId: alternateId,
      AgentId: agentId,
      FirstName: firstName,
      LastName: lastName,
      IdentityNumber: identityNumber,
      PostalCode: postalCode,
      MobileNumber: MobileNumber,
      NotificationPreference: notificationPreference,
      EmailId: emailId,
      UserName: userName,
      Password: password,
      RoleId: roleId,
      UserSecurityQA: userSecurityQA,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/registeragent",
    options
  );
  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
